import { h, Host } from "@stencil/core";
import ToggleButton from "./toggle";
/** The base className used for child elements */
const baseClass = "ux-collapsible";
/** The expand/collapse transition duration in ms */
const transitionDuration = 250;
export class Collapsible {
    constructor() {
        this.isExpanded = undefined;
        this.buttonTextCollapsed = undefined;
        this.direction = "top";
        this.buttonTextExpanded = undefined;
        this.centeredButton = false;
        this.buttonClass = "";
        this.accordion = false;
    }
    domNode;
    /** the content container html element */
    contentContainer = null;
    /** the content inner html element */
    contentInner = null;
    /** the current transition timeout id */
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    transitionTimeoutId = null;
    /** fired when the collapsible is expanded or collapsed  */
    collapsibleExpanded;
    setIsExpanded(currentlyExpanded) {
        if (this.transitionTimeoutId !== null) {
            clearTimeout(this.transitionTimeoutId);
            this.transitionTimeoutId = null;
        }
        // @ts-expect-error Check for typing
        const contentHeight = Math.ceil(this.contentInner.offsetHeight);
        // @ts-expect-error Check for typing
        this.contentContainer.style.height = `${contentHeight}px`;
        // @ts-expect-error Check for typing
        this.contentContainer.style.overflow = "hidden";
        if (currentlyExpanded) {
            this.transitionTimeoutId = setTimeout(() => {
                // @ts-expect-error Check for typing
                this.contentContainer.style.height = "auto";
                // @ts-expect-error Check for typing
                this.contentContainer.style.overflow = "visible";
            }, transitionDuration);
        }
        else {
            this.transitionTimeoutId = setTimeout(() => {
                // @ts-expect-error Check for typing
                this.contentContainer.style.height = "0";
            }, 10);
        }
    }
    toggleExpanded() {
        this.isExpanded = !this.isExpanded;
        this.collapsibleExpanded.emit(this.isExpanded);
    }
    componentDidLoad() {
        this.contentContainer = this.domNode.querySelector(`.${baseClass}-content__container`);
        this.contentInner = this.domNode.querySelector(`.${baseClass}-content__inner`);
    }
    render() {
        const buttonText = this.isExpanded ? this.buttonTextExpanded : this.buttonTextCollapsed;
        const containerClassName = {
            [baseClass]: true,
            [`${baseClass}--expanded`]: this.isExpanded,
            [`${baseClass}--collapsed`]: !this.isExpanded,
            [`${baseClass}--direction-bottom`]: this.direction === "bottom",
            [`${baseClass}--accordion`]: this.accordion
        };
        return (h(Host, { key: '4aff0b9a407d18f08cf6d1bf42683f63978d0c16' }, h("div", { key: '0b869f5be1e404868879e7334bc6605f39f3e5f4', class: containerClassName }, this.direction !== "bottom" && (h("div", { key: '884e8f4cb295b81f01d327a3a6db08af90e38dc1', class: `${baseClass}-content__container` }, h("div", { key: 'e04727600445146c6ab25676c2eadfc511a6ba80', class: `${baseClass}-content__inner`, "aria-hidden": !this.isExpanded }, h("slot", { key: 'cbd4ba5645bafe3c8b6ccc1a2c0c8c132000ff8b' })))), h("div", { key: '4137019eb0a502360dea84e7241c364e2d3dc828', class: {
                [`${baseClass}-button__container`]: true,
                [`${baseClass}-button__container--centered`]: this.centeredButton
            } }, h(ToggleButton, { key: '33bd1a85d64fb1dfbbaae0d87766caee9f003c99', baseClass: this.buttonClass !== "" ? this.buttonClass + " " + baseClass : baseClass, label: buttonText, onClick: () => this.toggleExpanded(), accordion: this.accordion })), this.direction === "bottom" && (h("div", { key: '79e4c32e2bab7d49aa0d685e40ba9ec8bdf15194', class: `${baseClass}-content__container` }, h("div", { key: '3508cde8a0815664f7792d8c2c106b332a81997d', class: `${baseClass}-content__inner`, "aria-hidden": !this.isExpanded }, h("slot", { key: '851ef3da970a8c0c078bdd6210e1262b78acda7b' })))))));
    }
    static get is() { return "ux-collapsible"; }
    static get originalStyleUrls() {
        return {
            "$": ["collapsible.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["collapsible.css"]
        };
    }
    static get properties() {
        return {
            "isExpanded": {
                "type": "boolean",
                "mutable": true,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "toggle expanded state"
                },
                "attribute": "is-expanded",
                "reflect": true
            },
            "buttonTextCollapsed": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "the toggle button text in default collapsed state"
                },
                "attribute": "button-text-collapsed",
                "reflect": false
            },
            "direction": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "direction of toggle opening"
                },
                "attribute": "direction",
                "reflect": false,
                "defaultValue": "\"top\""
            },
            "buttonTextExpanded": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "the toggle button text in expanded state"
                },
                "attribute": "button-text-expanded",
                "reflect": false
            },
            "centeredButton": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "if set, the toggle button will be in positioned in the middle"
                },
                "attribute": "centered-button",
                "reflect": false,
                "defaultValue": "false"
            },
            "buttonClass": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "extender class for button"
                },
                "attribute": "button-class",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "accordion": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "if set, the toggle button will look like an accordion and act like a collapsible"
                },
                "attribute": "accordion",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get events() {
        return [{
                "method": "collapsibleExpanded",
                "name": "uxCollapsibleExpanded",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "fired when the collapsible is expanded or collapsed"
                },
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                }
            }];
    }
    static get elementRef() { return "domNode"; }
    static get watchers() {
        return [{
                "propName": "isExpanded",
                "methodName": "setIsExpanded"
            }];
    }
}
//# sourceMappingURL=collapsible.js.map
